import React, { useState } from "react";
import { Dialog } from "@mui/material";
import styled from "@emotion/styled";
import { SECRETS } from "configs/secrets";

const Thumbnail = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 8px;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.1);
  }
`;

const FullImage = styled.img`
  max-width: 90vw;
  max-height: 90vh;
`;

export const ImagePreview = ({ src, alt = "Image" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Thumbnail
        src={
          src
            ? SECRETS.UPLOADS_URL + src
            : SECRETS.UPLOADS_URL + "DUMMY_IMAGE.PNG"
        }
        alt={alt}
        onClick={() => setOpen(true)}
      />
      <Dialog open={open} onClose={() => setOpen(false)}>
        <FullImage
          src={
            src
              ? SECRETS.UPLOADS_URL + src
              : SECRETS.UPLOADS_URL + "DUMMY_IMAGE.PNG"
          }
          alt={alt}
        />
      </Dialog>
    </>
  );
};
